import axiosNest from '../api/axiosNest';

/**
 * Ręczna archiwizacja prezlecenia (decyzja użytkownika 24.10.2026, A6:
 * prezlecenie nie wygasa samo; przełącznik `preOrderArchive`, S-25.10-01,
 * paczka CS i Administracja). Odpowiada `pre-order/pre-order-archive.ts`.
 */
export const FEATURE_PRE_ORDER_ARCHIVE = 'preOrderArchive';

/** Klucz filtra listy (dane — react-admin go zapamiętuje): `all` / `only`. */
export const ARCHIVE_FILTER_KEY = 'archived';

export const ARCHIVE_FILTER_CHOICES = [
  { id: 'all', name: 'Pokaż także zarchiwizowane' },
  { id: 'only', name: 'Tylko zarchiwizowane' },
];

/** Lustro `MIN_ARCHIVE_REASON_LENGTH` z API. */
export const MIN_ARCHIVE_REASON_LENGTH = 10;

export interface ArchiveResult {
  id: number;
  archivedAt: string | null;
  archivedBy: string | null;
  archivedReason: string | null;
  bankNote: string | null;
}

export async function archivePreOrder(id: number | string, reason: string): Promise<ArchiveResult> {
  const { data } = await axiosNest.post<ArchiveResult>(`/pre-orders/${id}/archive`, { reason });
  return data;
}

export async function restorePreOrder(id: number | string, reason: string): Promise<ArchiveResult> {
  const { data } = await axiosNest.post<ArchiveResult>(`/pre-orders/${id}/restore`, { reason });
  return data;
}

/** Czy wiersz z API jest zarchiwizowany. */
export const isArchived = (record: Record<string, unknown> | undefined): boolean =>
  typeof record?.archivedAt === 'string' && record.archivedAt !== '';
